import ax from '../axios'
import {API_URL} from "../index";
import { ID } from "../../constants";

const HOME_WORK_REPORT_URL = API_URL.EDUCATION_MODULE + '/homework-report'

const getTotalSummaryReport = (query: string) => {
    return ax.get(`${HOME_WORK_REPORT_URL}/total-summary?${query}`)
}
const getUserSummaryReport = (id: ID) => {
    return ax.get(`${HOME_WORK_REPORT_URL}/user-summary/${id}`)
}
const getHomeworkReport = (query: string) => {
    return ax.get(`${HOME_WORK_REPORT_URL}/homework-report?${query}`)
}
const getMostReaders = (query: string) => {
    return ax.get(`${HOME_WORK_REPORT_URL}/most-readers?${query}`)
}

export {
    getTotalSummaryReport,
    getHomeworkReport,
    getMostReaders,
    getUserSummaryReport
}
